import React from 'react';

const PlusIcon = () => (
<svg width="40" height="23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.594 1.207a1.394 1.394 0 0 0-1.976 0L19.994 18.83 2.37 1.207A1.396 1.396 0 0 0 .396 3.182l18.612 18.613a1.396 1.396 0 0 0 1.973 0L39.594 3.182c.252-.254.406-.602.406-.987s-.154-.735-.406-.988Z" fill="#000"/></svg>
);

export default PlusIcon;
